import api from "skin/http";

export default function reset(login, email) {
	return new Promise((resolve, reject) => {
		api.patch('api/auth/reset', { login, email })
		.then(resolve)
		.catch((e) => {
			console.log('Error ', e.response?.data);
			let msg = e.response?.data?.message;
			if (!msg) return reject([e.toString()]);
			if (!Array.isArray(msg)) msg = [msg];
			reject(msg);
		});
	})
}